import type { MeFieldsFragment, MyIdentityFieldsFragment } from '@mbfab/client-api'
import { isNull } from '@mbfab/shared'
import { createContext, useContext } from 'react'

// t/$tenant_id/route.tsx のゲート（useFetchMeQuery / useFetchMyIdentityQuery）を通過した後、
// 配下の画面が再度クエリを発行せずに現在のユーザー・テナント情報へアクセスできるようにする。
//
// myIdentity を併せて持つのは、サイドバーのメニュー表示制御に「Auth0 アカウント単位の情報」
// （運営管理者か / 所属テナントが複数か）が要るため。me はテナント単位の User なので、
// user.role によるテナント内権限は分かるが、identity.role や所属テナント数は分からない。
// v1 の Sider も fetchMe と fetchMyIdentity の両方を引いている
type MeContextValue = { me: MeFieldsFragment; myIdentity: MyIdentityFieldsFragment }

const MeContext = createContext<MeContextValue | undefined>(undefined)

export function MeProvider({
  me,
  myIdentity,
  children,
}: {
  me: MeFieldsFragment
  myIdentity: MyIdentityFieldsFragment
  children: React.ReactNode
}) {
  return <MeContext.Provider value={{ me, myIdentity }}>{children}</MeContext.Provider>
}

function useMeContext(hookName: string): MeContextValue {
  const value = useContext(MeContext)
  if (isNull(value)) {
    throw new Error(`${hookName} は MeProvider の外側では使えません`)
  }
  return value
}

export function useMe(): MeFieldsFragment {
  return useMeContext('useMe()').me
}

export function useMyIdentity(): MyIdentityFieldsFragment {
  return useMeContext('useMyIdentity()').myIdentity
}
